export const socialsData = {
    github: 'https://github.com/sunidhi014',
    linkedIn: 'https://www.linkedin.com/in/sunidhi-singh-44b05218b',
    blogger: 'https://dattebayo.hashnode.dev',
}